import { lazyChunk } from "@/lib/chunk-recovery";
import { createFileRoute } from "@tanstack/react-router";

import { seoLinks, absoluteUrl, ogImage } from "@/lib/seo";

const title = "Frågor och svar om skola och avgifter | SIS Estepona";
const description =
  "Vanliga frågor om svensk läroplan, antagning, avgifter, skoldagen, fritids, distansstudier, fotbollsakademin och att flytta till Costa del Sol med barn.";

const FaqPage = lazyChunk(() =>
  import("@/components/site/FaqPage").then((m) => ({ default: m.FaqPage })),
);

export const Route = createFileRoute("/fragor-och-svar")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: absoluteUrl("/fragor-och-svar") },
      { property: "og:locale", content: "sv_SE" },
      ...ogImage(),
    ],
    links: seoLinks("/fragor-och-svar"),
  }),
  component: FragorOchSvar,
});

function FragorOchSvar() {
  return <FaqPage locale="sv" />;
}
